/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import React from 'react';
import styles from '../../styles/profile/DetailsSection.module.css';
import InputField from '../controlVariations/InputField';
import Dropdown from '../controlVariations/Dropdown';
import MultiSelectDropdown from '../controlVariations/MultiSelectDropdown';

interface Field {
	label: string;
	value: string;
	key: string;
	placeholder?: string;
	type?: string;
	isDropdown?: boolean; // NEW
	options?: string[]; // NEW
	isMultiSelect?: boolean;
	error?: string | null;
	isChipInput?: boolean;
}

interface DetailsSectionProps {
	sectionTitle: string;
	iconSrc: string;
	fields: Field[];
	isEditing: boolean;
	onFieldChange?: (key: string, value: string) => void;
	height?: string | number;
}

const DetailsSection: React.FC<DetailsSectionProps> = ({
	sectionTitle,
	iconSrc,
	fields,
	isEditing,
	onFieldChange,
	height,
}) => {
	return (
		<div className={styles.detailsSection} style={{ height }}>
			<div className={styles.header}>
				<div className={styles.iconCont}>
					<img
						src={iconSrc}
						alt={sectionTitle}
						className={styles.icon}
					/>
				</div>
				<h3 className={styles.title}>{sectionTitle}</h3>
			</div>

			<div className={styles.fieldsContainer}>
				{fields.map((field, index) => (
					<div key={index} className={styles.fieldRow}>
						<label className={styles.label}>{field.label}</label>

						{/* {isEditing ? (
    field.isDropdown ? (
        <Dropdown
            options={field.options || []}
            selected={field.value}
            placeholder={field.placeholder || 'Select'}
            onSelect={(val) => onFieldChange?.(field.key, val)}
            width="100%"
        />
    ) : (
        <InputField
            type={field.type || 'text'}
            value={field.value || ''}
            placeholder={field.placeholder}
            disabled={field.key === 'email'}
            onChange={e =>
                onFieldChange?.(field.key, e.target.value)
            }
        />
    )
) : (
    <div className={styles.value}>{field.value}</div>
)} */}
						{isEditing ? (
							field.isMultiSelect ? (
								<MultiSelectDropdown
									options={field.options || []}
									selected={
										field.value
											? field.value
													.split(',')
													.map(v => v.trim())
											: []
									}
									placeholder={field.placeholder || 'Select'}
									onChange={vals =>
										onFieldChange?.(
											field.key,
											vals.join(', ')
										)
									}
									width="100%"
								/>
							) : field.isDropdown ? (
								<Dropdown
									options={field.options || []}
									selected={field.value}
									placeholder={field.placeholder || 'Select'}
									onSelect={val =>
										onFieldChange?.(field.key, val)
									}
									width="100%"
								/>
							) : (
								// <InputField
								//     type={field.type || 'text'}
								//     value={field.value || ''}
								//     placeholder={field.placeholder}
								//     disabled={field.key === 'email'}
								//     onChange={e =>
								//         onFieldChange?.(field.key, e.target.value)
								//     }
								// />
								<div style={{ width: '100%' }}>
									<InputField
										type={field.type || 'text'}
										value={field.value || ''}
										placeholder={field.placeholder}
										disabled={field.key === 'email'}
										onChange={e =>
											onFieldChange?.(
												field.key,
												e.target.value
											)
										}
									/>

									{field.error && (
										<div
											style={{
												color: 'red',
												fontSize: '12px',
												marginTop: '4px',
											}}
										>
											{field.error}
										</div>
									)}
								</div>
							)
						) : // <div className={styles.value}>{field.value}</div>
						field.isMultiSelect || field.isChipInput ? (
							<div className={styles.chipContainer}>
								{(field.value || '')
									.split(',')
									.map((item, i) => (
										<span key={i} className={styles.chip}>
											{item.trim()}
										</span>
									))}
							</div>
						) : (
							<div className={styles.value}>{field.value}</div>
						)}
					</div>
				))}
			</div>
		</div>
	);
};

export default DetailsSection;
